// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3i3ox","notes":"Notes_notes__3JZ87","note":"Notes_note__203f3","markdown":"Notes_markdown__1mgVX"};